// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"gY-z"};